import script from "./AllyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AllyModal.vue?vue&type=script&setup=true&lang=js"

import "./AllyModal.vue?vue&type=style&index=0&id=5da41dcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da41dcf"]])

export default __exports__